// Původní název:		sk.widgets.Tabs
// Původní umístění:	shared/js/widget/sk.widgets.Tabs.js
// Status:				Používáno
// Funkcionalita:		Taby
// TODO regulár na komplikovanější hash (#hash1&hash2&tab=test)
// TODO nevhodná inicializace přes ID napříč skripty - změnit
// TODO A11Y - aktuálně nic moc
// #CHECKED jthiemel 190107


import $ from 'jquery';


class Tabs {
	constructor(element, options) {
		this.$element = element.jquery ? element : $(element);
		this.options = $.extend({
			current: 0,
			item: 'a',
			eventName: 'click touchstart',
			tabHideClass: 'sk-tab-hide',
			menuActiveClass: 'active',
			onActiveTab: function () { },
			history: false,
		}, options);
		this.startIndex = this.currentIndex = this.options.current;
		this.currentId = null;
		// tabs menu
		this.$menu = this.$element.find(this.options.item);
		// tabs fragment
		var $tabs = $([]);
		this.$menu.each(function () {
			$tabs = $tabs.add($(this).attr('href'));
		});
		this.$tabs = $tabs;

		return this;
	}

	init() {
		if (!this.$element.length) {
			return this;
		}

		var o = this.options;
		this.$menu.bind(o.eventName, $.proxy(this.handle, this));

		// určování která záložka má být defaultně aktivní
		if (o.history) {
			this.hash();
		}
		else {
			this.set(this.currentIndex);
		}

		return this;
	}

	hash() {
		var o = this.options;
		// určování která záložka má být defaultně aktivní
		var tab = '';
		var scroll = '';

		var hash = location.hash.split('#');
		hash = hash[hash.length - 1];

		if (hash && hash != 'tab=') {
			hash = hash.split('tab=');
			hash = hash[hash.length - 1];
			this.$tabs.each(function () {

				if ($(this).is('#' + hash)) {
					tab = '#' + $(this).attr('id');

					if (location.hash.indexOf('tab=') == -1) {

						scroll = '#' + hash;
					}
				}
				else if ($(this).find('#' + hash).length) {
					tab = '#' + $(this).attr('id');
					scroll = '#' + hash;
				}

			});

			// tab na který chci jit je neaktivni -> hodim na 1. tab
			if (this.$menu.filter('[href="' + tab + '"]').hasClass('inactive')) {
				this.currentIndex = this.startIndex;
				tab = '';
			}
		}
		// pokud není žádný hash vrátit do startovní záložky
		else if (!/#$/.test(location.href)) {
			this.currentIndex = this.startIndex;
		}

		this.set(tab || this.currentIndex, scroll);
	}

	handle(e) {
		var $target = $(e.currentTarget);

		if ($target.hasClass('inactive')) // klikl jsem na neaktivni tab
		{
			e.preventDefault();
			return;
		}

		var href = $target.attr('href').split('#');

		href = href[href.length - 1];

		if (this.options.history) {
			// pokud záložka již není aktivní tak nastavit
			if (!$target.hasClass(this.options.menuActiveClass)) {
				location.hash = '#tab=' + href;
			}
		}
		else {
			this.set('#' + href);
		}

		e.preventDefault();
	}

	set(current, scroll) {
		var id = typeof current == 'number' ? this.$menu.eq(current).attr('href') : current;

		if (this.currentId !== id) {
			this.currentIndex = this.$menu.filter('[href="' + id + '"]').index();
			this.currentId = id;
			this.setTab(id);
			this.setMenu(id);

			scroll && $('html, body').animate({ 'scrollTop': $(scroll).offset().top - 100 }, 500);
		}
	}

	setTab(id) {
		this.$tabs
			.filter(id)
			.removeClass(this.options.tabHideClass)
			.end()
			.not(id)
			.addClass(this.options.tabHideClass);

		this.options.onActiveTab.call(this);
	}

	setMenu(id) {
		this.$menu
			.removeClass(this.options.menuActiveClass)
			.filter('[href="' + id + '"]')
			.addClass(this.options.menuActiveClass);
	}
}

export default Tabs;
